/* eslint-disable sonarjs/no-duplicate-string */
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/Error';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import { getSpidipayCheckoutResultOfOrder } from 'api/api';
import { useState } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { useMedia } from 'react-use';

const toFirstCapitalNoUnderscore = (text: string) => {
  return (
    text.charAt(0).toUpperCase() + text.slice(1).toLowerCase().replace('_', ' ')
  );
};

export function CheckoutResult() {
  const navigate = useNavigate();
  // const { orderId } = useParams<{ orderId: string }>();

  const isMobile = useMedia('(max-width: 900px)');

  const [orderError, setOrderError] = useState<any>({});

  const {
    data: response,
    isLoading,
    error,
  } = useQuery(['checkoutResult'], getSpidipayCheckoutResultOfOrder(), {
    refetchOnWindowFocus: false,
    retry: 0,
  });

  const result: any = response?.data;

  return (
    <>
      <Box
        className="CheckoutResult page"
        sx={{
          width: '100%',
          maxWidth: '900px',
          marginInline: { md: 'auto' },
          mt: { md: '32px' },
        }}
      >
        {!result && !error && (
          <Box sx={{ mt: 8, textAlign: 'center' }}>
            <CircularProgress />
          </Box>
        )}

        {!!result && result.status === 'SUCCESSFUL' && (
          <>
            <Box
              sx={{
                mt: { xs: '32px', sm: '48px' },
                textAlign: 'center',
              }}
            >
              <DoneIcon
                sx={{
                  width: '120px',
                  height: '120px',
                  color: '#666',
                }}
              />
              <br />
              <Typography>
                The {result.ticketCount > 1 ? 'tickets have ' : 'ticket has '}
                been sent to the given email address. Check the spam folder if
                it is not in your inbox.
              </Typography>
              <br />
              Thank you for your purchase!
              <br />
              <Button
                sx={{ mt: 8 }}
                variant="outlined"
                onClick={() => navigate('/')}
              >
                Back to the main screen
              </Button>
            </Box>
          </>
        )}

        {!!result && result.status === 'PENDING' && (
          <>
            <Box
              sx={{
                mt: { xs: '32px', sm: '48px' },
                textAlign: 'center',
              }}
            >
              <Typography>
                Please complete your payment on Spidipay, or wait for the order
                to time out and try again.
              </Typography>
              <Button
                sx={{ mt: 8 }}
                variant="outlined"
                onClick={() => navigate('/')}
              >
                Back to the main screen
              </Button>
            </Box>
          </>
        )}

        {!!error && (
          <Box sx={{ mt: 4, mb: 1, textAlign: 'center' }}>
            <ErrorIcon
              sx={{ width: '120px', height: '120px', color: '#666' }}
            />
            <br />
            Sorry, your order was unsuccessful. Try again.
            <br />
            {!!orderError?.message &&
              toFirstCapitalNoUnderscore(orderError?.message)}
            <br />
            <Button
              sx={{ mt: 8 }}
              variant="outlined"
              onClick={() => navigate('/')}
            >
              Back to the main screen
            </Button>
          </Box>
        )}

        {!!result && result.status === 'NOT_FOUND' && (
          <Box sx={{ mt: 8, mb: 1, textAlign: 'center' }}>
            You do not have a pending order.
            <br />
            <Button
              sx={{ mt: 8 }}
              variant="outlined"
              onClick={() => navigate('/')}
            >
              Back to the main screen
            </Button>
          </Box>
        )}
      </Box>
    </>
  );
}

export default CheckoutResult;
